import * as Sentry from "@sentry/react";
import { ENV } from "@/config";
import { isChunkLoadError } from "./chunk-recovery";

let initialized = false;

/** Browser Sentry init. No-op without a DSN, outside the production host, or when called twice. */
export function initSentry() {
  if (initialized || !ENV.sentryDsn) return;
  if (window.location.hostname !== ENV.productionHost) return;
  initialized = true;

  Sentry.init({
    dsn: ENV.sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: "production",
    // In-app browsers (Instagram, Facebook, TikTok, ...) inject scripts that throw when their
    // native bridge is missing — third-party code we neither ship nor control.
    ignoreErrors: [/webkit[.]messageHandlers/i, /window[.]webkit/i],
    // Stale chunks after a deploy self-heal via a reload: keep them as one grouped warning.
    beforeSend(event, hint) {
      if (isChunkLoadError(hint.originalException)) {
        event.level = "warning";
        event.fingerprint = ["stale-chunk-after-deploy"];
      }
      return event;
    },
  });
}

export { Sentry };
